import { baseUrl, responseToAsyncSelect, notify } from "./index";
import {
  getToken,
  getUser,
  retreiveCachedResponse,
  cacheResponse
} from "./storage";

export async function getStoreComments(store_id) {
  const token = await getToken();
  let comments = [];

  try {
    let response = await (await fetch(`${baseUrl}/store/inspections`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ store_id })
    })).json();

    comments = response.data.data;
    cacheResponse(`getStoreComments:${store_id}`, comments);
  } catch (error) {
    console.error(error);
    comments = await retreiveCachedResponse(`getStoreComments:${store_id}`);
  }

  return comments;
}

export async function getStoreComment(inspection_id) {
  const token = await getToken();
  let comment = {};
  try {
    let response = await (await fetch(
      `${baseUrl}/store/inspections/${inspection_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )).json();

    response.data.require_action = Boolean(response.data.require_action);
    response.data.machines = response.data.inspections;
    response.data.complete = Boolean(response.data.complete);

    comment = response.data;
    cacheResponse(`getStoreComment:${inspection_id}`, comment);
  } catch (error) {
    console.error(error);
    comment = await retreiveCachedResponse(`getStoreComment:${inspection_id}`);
  }

  return comment;
}

export async function getStore(store_id) {
  const token = await getToken();
  let store = {};

  try {
    let response = await (await fetch(`${baseUrl}/store`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ store_id })
    })).json();

    store = response.data[0];
    cacheResponse(`getStore:${store_id}`, store);
  } catch (error) {
    console.error(error);
    store = await retreiveCachedResponse(`getStore:${store_id}`);
  }

  return store;
}

export async function getStores(name) {
  let stores;

  if (name.length < 3) {
    stores = [];
  } else {
    const token = await getToken();
    try {
      let response = await (await fetch(`${baseUrl}/stores`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ name })
      })).json();

      stores = responseToAsyncSelect(response, "id", "name");
      cacheResponse("getStores", stores, true, "value");
    } catch (error) {
      console.error(error);
      stores = await retreiveCachedResponse("getStores");
      stores = stores.filter(({ label }) =>
        label.toLowerCase().includes(name.toLowerCase())
      );
    }
  }

  return stores;
}

export async function getNearbyStores({ postCode }) {
  const token = await getToken();
  // Trim the postcode to increase the search radius
  if (postCode.length >= 4) {
    postCode = postCode.slice(0, 3);
  }

  try {
    // If the cached data is fresh enough use that
    const { data, timestamp } = await retreiveCachedResponse("getNearbyStores");
    if (Date.now() - timestamp < 1000 * 60 * 5) {
      return data;
    }

    let response = await (await fetch(`${baseUrl}/stores/${postCode}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).json();

    cacheResponse("getNearbyStores", {
      data: response.data.data,
      timestamp: Date.now()
    });
    return response.data.data;
  } catch (error) {
    console.error(error);
    return (await retreiveCachedResponse("getNearbyStores")).data;
  }
}

export async function createStoreComment({
  store_id,
  priority,
  inspection_note,
  machines,
  require_action
}) {
  let { id } = await getUser();
  let token = await getToken();
  let response = {};
  const title = `${inspection_note} - ${new Date().toString()}`;
  const label = "STORE COMMENT FORM";

  // Adding in required props if they dont exist
  machines = machines.map(({ machine_id, machine_status }) => ({
    require_swap: false,
    machine_id,
    id: machine_id,
    machine_status
  }));

  const url = `${baseUrl}/inspection/store`;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: id,
      priority,
      require_action,
      inspection_note,
      store_id,
      machines: machines
    })
  };

  try {
    response = await fetch(url, options);
  } catch (error) {
    cacheResponse("savedForms", { url, options, label, title }, true);
    notify("Failed to post, added to saved forms", "error");
  }

  return response;
}

export async function updateStoreComment({
  group_id,
  complete,
  added_note,
  store_id
}) {
  let token = await getToken();
  let response = {};

  const title = `${added_note} - ${new Date().toString()}`;
  const label = "UPDATE STORE COMMENT";
  const url = `${baseUrl}/store/inspections/${group_id}/update`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ complete, added_note, store_id })
  };

  try {
    response = await fetch(url, options);
  } catch (error) {
    cacheResponse("savedForms", { url, options, label, title }, true);
    notify("Failed to post, added to saved forms", "error");
  }

  return response;
}



// WEBPACK FOOTER //
// ./src/backend/stores.js